function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { SyncLoader } from 'react-spinners';
import Chart from 'js/components/organisms/Chart/Bar/Column';
import RadioButtonForm from '../../../../Form/Plot/Controls/Resolution';
import Footer from '../../../Footer';
import 'scss/cndc_prices.scss';
import { PlotContainer, SpinnerBox, Label, LegendContainer, SectionContainer, ControlsContainer, ItemContainer, Space, ClearPlotButtonContainer, Panel } from './style';

var Section =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Section, _React$Component);

  function Section() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Section);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Section)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (id) {
      _this.props.actions.setCurrentData(_this.props.countryID, _this.props.plot.metadata.id, id);
    };

    _this.render = function () {
      var data = _this.props.plot.currentState ? _this.props.plot.currentState.data : false;
      var controls_data = [];

      if (_this.props.plot.controls && _this.props.plot.controls.data_types) {
        var newData = _this.props.plot.controls.data_types;
        newData.map(function (a) {
          return controls_data.push(a.id);
        });
      }

      var height = _this.props.height;
      return React.createElement(SectionContainer, {
        height: height
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement("h3", {
        className: "cndc-graph-section__title"
      }, _this.props.plot.metadata.title), _this.props.plot.metadata.description ? React.createElement("p", null, _this.props.plot.metadata.description) : React.createElement(Space, {
        heigth: '20px'
      }))), React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-sm-3 col-md-3"
      }, React.createElement(Panel, {
        height: '420px'
      }, React.createElement(LegendContainer, {
        height: '210px'
      }), controls_data && data ? React.createElement(ControlsContainer, null, React.createElement(ItemContainer, null, React.createElement(Label, null, "Data resolution"), React.createElement(RadioButtonForm, {
        default: data.id,
        handleClick: function handleClick(e) {
          return _this.handleClick(e);
        },
        data: controls_data
      }))) : '', React.createElement(ClearPlotButtonContainer, null))), data ? React.createElement("div", {
        className: "col-sm-9 col-md-9"
      }, React.createElement(Chart, {
        data: data,
        plot: _this.props.plot,
        actions: _this.props.actions,
        plotID: _this.props.plot.metadata.id,
        countryID: _this.props.countryID,
        controls: _this.props.plot.controls,
        windowWidth: _this.props.windowWidth,
        loading: _this.props.plot.currentState.loading,
        checkboxState: _this.props.plot.controls.dataShown.checkbox
      })) : React.createElement(PlotContainer, {
        className: "col-sm-9 col-md-9"
      }, React.createElement(SpinnerBox, null, React.createElement(SyncLoader, {
        color: "#e9eded"
      }))), _this.props.plot.controls ? React.createElement(Footer, {
        calendar: 'readOnly',
        actions: _this.props.actions,
        countryID: _this.props.countryID,
        plotID: _this.props.plot.metadata.id,
        range: _this.props.plot.controls.range,
        resolution: _this.props.plot.controls.time_resolution,
        disabled: _this.props.plot.currentState ? _this.props.plot.currentState.loading : true
      }) : React.createElement(Footer, {
        plotID: _this.props.plot.metadata.id,
        range: {}
      })));
    };

    return _this;
  }

  return Section;
}(React.Component);

export { Section as default };
Section.propTypes = {
  countryID: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  plot: PropTypes.object.isRequired,
  height: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
  windowWidth: PropTypes.number.isRequired
};